import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import "./TermsPageSingle.css"; 

const TermsPage = () => {
    const navigate = useNavigate();

    useEffect(() => {
        document.title = "Terms & Conditions"; 
    }, []);

    return (
        <div className="terms-container-main">
            <div className="terms-header-main">
                <h1>Terms & Conditions</h1>
                <p>Please read our terms and conditions carefully before proceeding.</p>
            </div>

            <div className="terms-viewer-main">
                <iframe 
                    // src="/terms.pdf#view=FitH&scrollbar=1&statusbar=0&messages=0&navpanes=1"  
                    // src="https://get-fit-global.tor1.cdn.digitaloceanspaces.com/Terms/TermsOfService.pdf#view=FitH&scrollbar=1&statusbar=0&messages=0&navpanes=1"  
                    // todo - change this to cdn
                    src = "/Plus_Life_Terms_of_Service.pdf"
                    className="pdf-frame-main"
                    title="Terms & Conditions Document"  
                />
            </div>

            <div className="terms-actions-main">
                <button className="back-btn-main" onClick={() => navigate("/")}>
                    Back to Home
                </button>
            </div>
        </div>
    );
};

export default TermsPage;
